import { AppPageHeader, DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { workorderRoutes } from '../route';
import { useIntl } from 'react-intl';
import WorkOrderMigrationConsultList from '@/components/Movements/WorkOrders/MigrationConsult';
import { Button, Space } from 'antd';
import { WorkOrderMigrateConsultListRequest } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { convertParams, usePersistSearchParams } from '@/utils/queryParams';
import { useState } from 'react';
import MigrationConsultFilter from '@/components/Movements/WorkOrders/MigrationConsult/MigrationConsultFilter';
import { useDisclosure } from '@/hooks';
import MigrationConsultReportModal from '@/components/Movements/WorkOrders/MigrationConsult/MigrationConsultReportModal';

export default function WorkOrderMigrationConsultListPage({
  route,
}: PageProps) {
  const intl = useIntl();

  const [queryParams, setQueryParams] =
    useState<WorkOrderMigrateConsultListRequest>({
      order: 1,
      ...convertParams<WorkOrderMigrateConsultListRequest>({
        search: 'string',
        order: 'number',
        companyId: 'number',
        estimatedLeaveDate: 'string',
        entryDate: 'string',
        authorizationDate: 'string',
        closingDate: 'string',
        returnDate: 'string',
        status: 'string',
        type: 'string',
        originSystemIds: 'array-number',
        hasLinkedWorkOrders: 'boolean',
      }),
    });

  const [modalReportOpen, modalReportAction] = useDisclosure(false);

  usePersistSearchParams(queryParams);

  const newRoute = {
    ...route.parent,
    routes: [
      route.parent,
      ...route.parent.routes.filter((route) =>
        workorderRoutes.includes(route.key),
      ),
    ],
  };

  return (
    <>
      <DefaultRouteTabs
        route={newRoute}
        permissions={route.permissions}
        extra={
          <Space align="center">
            <Button block type="primary" onClick={modalReportAction.open}>
              Gerar relatório
            </Button>
          </Space>
        }
      >
        <Helmet title={intl.formatMessage({ id: route.name })} />

        <AppPageHeader
          onSearch={(value) =>
            setQueryParams((prev) => ({ ...prev, search: value }))
          }
          searchValue={queryParams.search}
          headerActions={({ isShowingFilters }) =>
            isShowingFilters && (
              <Button
                type="primary"
                onClick={() => setQueryParams({ order: 1 })}
              >
                {intl.formatMessage({ id: 'commons.clear.filters' })}
              </Button>
            )
          }
          extraFilters={
            <MigrationConsultFilter
              queryParams={queryParams}
              setQueryParams={setQueryParams}
            />
          }
        />

        <WorkOrderMigrationConsultList queryParams={queryParams} />

        <MigrationConsultReportModal
          open={modalReportOpen}
          onCancel={modalReportAction.close}
        />
      </DefaultRouteTabs>
    </>
  );
}
